// DonationsWrapper.js
import React, { useEffect, useState } from 'react';
import Donations from './Donations/Donation1';


function DonationsWrapper() {
    const [userCountry, setUserCountry] = useState(null);

    useEffect(() => {
        const fetchCountry = async () => {
            try {
                const response = await fetch('https://ipinfo.io?token=f667c2c73c3553');
                const data = await response.json();
                setUserCountry(data.country);
            } catch (error) {
                console.error('Error fetching user country:', error);
                // Handle error
            }
        };

        fetchCountry();
    }, []);

    // Render Donations component if user is from India, otherwise redirect to another URL
    return (
        <>
            {userCountry === 'IN' ? (
                <Donations />
            ) : (
                window.location.href = 'https://lovewithoutreasonusa.harnessgiving.org/donate/'
            )}
        </>
    );
}

export default DonationsWrapper;
